import { modalAnatomy } from '@chakra-ui/anatomy';

import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(modalAnatomy.keys);

const Modal = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    overlay: {
      zIndex: 9999999,
    },
    dialogContainer: {
      zIndex: 9999999,
    },
    dialog: {
      zIndex: 9999999,
    },
    closeButton: {
      zIndex: 9999999,
    },
  }),
});

export { Modal };
